import React from "react";
import useCountUp from "../hook/useCountUp";

const StatCard = ({ icon, value, label, suffix = "", format = (n) => n }) => {
    const isNumeric = typeof value === "number" && !isNaN(value);
    const animated = useCountUp(isNumeric ? value : 0);

    return (
        <div className="relative flex-1 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
            <div className="flex flex-col items-center justify-center px-2 py-3 text-center">
                {/* gradient-tint icon chip */}
                <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
                    <img
                        src={icon}
                        alt={label}
                        className="h-6 w-6 object-contain"
                    />
                </div>
                <div className="bold text-xl leading-none text-dark">
                    {isNumeric ? (
                        <>
                            {format(Math.round(animated))}
                            {suffix}
                        </>
                    ) : (
                        value
                    )}
                </div>
                <div className="medium mt-1 text-[11px] uppercase tracking-wide text-gray-400">
                    {label}
                </div>
            </div>
            {/* bottom accent bar */}
            <div className="h-[3px] w-full bg-gradient-to-r from-primary to-primaryDark" />
        </div>
    );
};

export default StatCard;
